import './setupDayjs';

import dayjs from 'dayjs';

import {not} from '../conditionalUtils';
import {isDefined} from '../typecheck';
import {getTimezoneOffset} from './getTimezoneOffset';

export const makeTimezoneWithOffset = (timezoneName?: string) => {
  if (not(isDefined(timezoneName))) {
    timezoneName = dayjs.tz.guess();
  }

  const offset = getTimezoneOffset(timezoneName);

  return `${timezoneName} ${offset}`;
};
